export const converter = {
  highlight: (text: string) => {
    if (!text) return '';

    const highlightColor = '#1C9CFF';

    return text.replaceAll(/\{\{(.*?)\}\}/g, (_, p1) => {
      return `<span style="color:${highlightColor}; font-weight:700">${p1.trim()}</span>`;
    });
  },
  sanitizeHTML: (dirty: string) => {
    if (!dirty) return '';

    return dirty
      .replaceAll(/<(?!span(?=\s|>))[^>]+>/gi, '')
      .replaceAll(/<(span)(?!\s*style=)[^>]*>/gi, '<span>')
      .replaceAll(/<(?!\/?span(?:\s|>))/gi, '&lt;')
      .replaceAll(/<span\s+style="([^"]*)"/gi, (_, style) => {
        const safeStyle = style
          .replaceAll(/expression\s*\([^)]*\)/gi, '')
          .replaceAll(/javascript:/gi, '')
          .replaceAll(/url\s*\([^)]*\)/gi, '');

        return `<span style="${safeStyle}"`;
      })

      .replaceAll(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '');
  },
};
